const RiskDebtAmortisationTypeEnumEnum = {
  ANNUALLY : 'ANNUALLY',
  QUARTERLY: 'QUARTERLY'
}

export default RiskDebtAmortisationTypeEnumEnum
